module.exports = __webpack_public_path__ + "static/media/EventWeighing.726e1f6a.png";